// extracted by css-extract-rspack-plugin
export default {"root":"root-gIhSyE","title":"title-mQciqs","control":"control-LOFJQr","mobileImage":"mobileImage-VPluC5","desktopImage":"desktopImage-mAB82r"};